import { Label } from "../ui/label";
import { Input } from "../ui/input";

import { cn } from "../../utils/lib";

export function InputFieldPlaceHolder({ icon, htmlFor, id, value }) {
  return (
    <div className="relative">
      <Input
        id={id}
        value={value}
        disabled={true}
        autoComplete="off"
        className={cn(
          "focus-visible:ring-offset-0 bg-[#131821] text-[#4E5665] border border-[#353C4A] block w-full truncate focus:ring-0 placeholder:truncate focus:outline-none ring-transparent focus-visible:border disabled:border disabled:opacity-90 disabled:bg-[#131821] disabled:shadow-none focus-visible:border-transparent focus-visible:ring-none focus-visible:border-[#353C4A] px-8",
          "text-white"
        )}
      />

      <Label
        htmlFor={htmlFor}
        className="absolute left-3 top-1/2 -translate-y-1/2"
      >
        {icon}
      </Label>
    </div>
  );
}
